import React from 'react';
import { ContentfulEntry } from '@jbhi-fi/apis/src/contentful/types';
import { ListingBlock } from '../ListingBlock';
import { ArticleBlockTransformer } from '../Contentful/transformers/ArticleBlockTransformer';
import { ListingBlockTransformer } from '../Contentful/transformers/ListingBlockTransformer';
import { ContactBlockTransformer } from '../Contentful/transformers/ContactBlockTransformer';
import { CarouselTransformer } from '../Contentful/transformers/CarouselTransformer';
import { ContactBlock } from '../ContactBlock';
import { TabsBlock } from '../TabsBlock/TabsBlock';
import { PromoCard } from '../PromoCard/PromoCard';
import { PromoCardTransformer } from '../Contentful/transformers/PromoCardTransformer';
import { ProductBlockTransformer } from '../Contentful/transformers/ProductBlockTransformer';
import { HeroBanner } from '../HeroBanner/HeroBanner';
import { LeaderboardBannerTransformer } from '../Contentful/transformers/LeaderboardBannerTransformer';
import { ContentfulPagesList } from '../ContentfulPagesList/ContentfulPagesList';
import { PageListingTransformer } from '../Contentful/transformers/PageListingTransformer';

export type ContentEntry = {
  Component: React.VFC<any>;
  transformer: (entry: ContentfulEntry<any>) => Record<string, any> | undefined;
};

type ContentEntryKey =
  | 'listingBlock'
  | 'contactBlock'
  | 'articleBlock'
  | 'carousel'
  | 'promoCard'
  | 'productBlock'
  | 'leaderboardBanner'
  | 'pageListing';

export const getContentEntry = (
  entry: ContentfulEntry<unknown>,
  overrides: Partial<typeof CONTENT_ENTRIES> = {}
): ContentEntry | undefined => {
  const entryKey = entry?.sys?.contentType?.sys?.id as ContentEntryKey | undefined;
  const contentEntry = entryKey ? { ...CONTENT_ENTRIES, ...overrides }[entryKey] : undefined;
  return typeof contentEntry === 'function' ? contentEntry(entry) : contentEntry;
};

export const CONTENT_ENTRIES: Record<ContentEntryKey, ContentEntry | ((entry: ContentfulEntry<any>) => ContentEntry)> =
  {
    listingBlock: {
      Component: ListingBlock,
      transformer: ListingBlockTransformer.toListingBlockProps,
    },
    contactBlock: {
      Component: ContactBlock,
      transformer: ContactBlockTransformer.toContactBlockProps,
    },
    articleBlock: {
      Component: TabsBlock,
      transformer: ArticleBlockTransformer.toTabsBlockProps,
    },
    carousel: CarouselTransformer.toContentEntryProps,
    promoCard: {
      Component: PromoCard,
      transformer: PromoCardTransformer.toPromoCardProps,
    },
    productBlock: {
      Component: TabsBlock,
      transformer: ProductBlockTransformer.toTabsBlockProps,
    },
    leaderboardBanner: {
      Component: HeroBanner,
      transformer: LeaderboardBannerTransformer.toHeroBannerProps,
    },
    pageListing: {
      Component: ContentfulPagesList,
      transformer: PageListingTransformer.toContentfulPagesListProps,
    },
  };
